import { DASHBOARD_TABS } from './constants';
import { type DashboardTab } from './StudentDashboard.types';

export const isValidDashboardTab = (tab: string | undefined): tab is DashboardTab =>
    DASHBOARD_TABS.includes(tab as DashboardTab);
